import { Supplier } from './supplier';

export class SupplierApiMessageMap {
	public id: number;
	public userId: string;
	public modifiedUserId: string;
	public supplierId: string;
	public oldMessage: string;
	public newMessage: string;
	public isActive: boolean;
	public isPartialMatch: boolean;
	public addDate: string;
	public modifiedDate: string;

	public supplier: Supplier;

	constructor(supplierApiMessageMap?: SupplierApiMessageMap) {
		Object.assign(this, supplierApiMessageMap);
	}
}
